module.exports = __webpack_public_path__ + "img/service-communication.bb9efb49.jpg";